/**
 * Track a conversion event with google tag manager
 * @returns {void}
 */
export const trackConversion = () => {
  const DL_KEY = 'tcc_gtm_dataLayer';
  const TCC_GTM_KEY = 'GTM-K78GNRZ';

  // check for data layer array on window object and create one if necessary
  window[DL_KEY] = window[DL_KEY] || [];
  window[DL_KEY].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });

  // remove any GTM script tags that are already on the page
  const documentScriptTags = document.getElementsByTagName('script');
  for (let i = 0; i < documentScriptTags.length; i++) {
    const tag = documentScriptTags[i];
    if (tag.src.includes('www.googletagmanager.com')) {
      tag.parentNode.removeChild(tag);
    }
  }


  // create GTM script tag and add to document
  const newGtmTag = document.createElement('script');
  newGtmTag.async = true;
  newGtmTag.src = `https://www.googletagmanager.com/gtm.js?id=${TCC_GTM_KEY}&l=dataLayer`;
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(newGtmTag, firstScriptTag);
};
